import { render, staticRenderFns } from "./LiveChatAutoTree.vue?vue&type=template&id=99e966a2&"
import script from "./LiveChatAutoTree.vue?vue&type=script&lang=js&"
export * from "./LiveChatAutoTree.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatAutoTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports